<template>

  <v-card v-if="order" class="order-card" @click="itemClicked">
    <v-container fluid class="pb-4">
      <v-row class="pa-0 ma-0">
        <!-- (order number, provider name) -->
        <v-col cols="6" md="6" class="pa-0 ma-0">
          <div class="order-number"># {{ order.order_number }}</div>
          <!-- <div class="mt-2 provider-name">{{ providerNameForDisplay }}</div> -->
          <div class="mt-2 brand-name">{{ brandName }}</div>
        </v-col>
        <!-- (order status, placed date) -->
        <v-col cols="6" md="6" class="pa-0 ma-0 d-flex flex-column align-center justify-center order-status-badge">
          <div class="d-flex align-center">
            <div class="pr-2" v-if="order.is_test">
              <v-chip label color="orange darken-4" style="font-weight:500;">TEST ORDER</v-chip>
            </div>
            <v-chip label outlined :class="order.order_status">
              {{ order.order_status }}
            </v-chip>
          </div>
          <div class="mt-2 placed-date">
            {{ formatDate(order.placed_at) }}
          </div>
        </v-col>
      </v-row>

      <v-row class="pa-0 ma-0 mt-2">
        <v-col cols="6" md="6" class="pa-0 ma-0">
          <div class="loc-info">
            <div class="loc-label">{{ shipperLocationName }}</div>
          </div>
          <div class="loc-info label-delivering-to">
            to
          </div>
          <div class="loc-info">
            <div class="loc-label">{{ receiverLocationName }}</div>
          </div>
        </v-col>

        <v-col cols="6" md="6" class="pa-0 ma-0 d-flex flex-column align-center justify-center">
          <div class="label" style="margin-bottom:6px;">
            Expected By
          </div>
          <div class="expected-date">
            {{ expectedDateForDisplay }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>

</template>

<script>
import dateTimeUtils from '@/utils/date-time-utils'

export default {
  name: 'OrderCard',

  props: {
    order: {
      type: Object,
      default: null
    }
  },

  computed: {
    providerNameForDisplay () {
      return this.$root.providerAliasToName(this.order.provider_alias)
    },
    brandName () {
      return this.order.thirdparty_brand_name
    },
    shipperLocationName () {
      return (this.order.shipper) ? this.order.shipper.name : '-'
    },
    receiverLocationName () {
      return (this.order.receiver) ? this.order.receiver.name : '-'
    },
    expectedDateForDisplay () {
      return (this.order.expected_delivery)
        ? dateTimeUtils.format(this.order.expected_delivery, 'MMM D, YYYY')
        : '-'
    }
  },

  methods: {
    formatDate (date) {
      return (date) ? dateTimeUtils.format(date, 'MMMM D, YYYY h:mm a') : '-'
    },

    itemClicked () {
      this.$emit('itemClicked', this.order)
    }
  }
}

</script>

<style>
  /* .order-card {
    min-height: 210px;
  } */

  .order-card .order-number {
    font-size: 20px;
  }

  .order-card .provider-name {
    color: #20ADD8;
    font-size: 16px;
  }

  .order-card .brand-name {
    color: #20ADD8;
    font-size: 16px;
  }

  .order-card .placed-date {
    color: #9c9c9c;
    font-size: 14px;
    font-style: italic;
  }

  .order-card .expected-date {
    font-size: 18px;
  }

  /* --------------------------------------------------------------- loc-info */

  .order-card .loc-info {
    color: #9c9c9c;
    font-size: 14px;
  }

  .order-card .label-delivering-to {
    width: 100px;
    color: #525252;
    font-size: 13px;
    text-align: center;
  }

  /* -------------------------------------------------------- receiving-times */

  .receiving-times .receiving-times-text {
    font-size: 14px;
    margin-top: 1px;
    margin-bottom: 4px;
  }
</style>
